/* Presentation and quantity shortcuts only. All writes remain in the guarded shared CartAdapter. */
'use strict';
(() => {
  const money = cents => new Intl.NumberFormat('en-AU', {
    style: 'currency', currency: window.ToscaShop?.currency || 'AUD'
  }).format(cents / 100);
  const formData = new WeakMap();
  for (const form of document.querySelectorAll('.shop-buy')) {
    let variants;
    try { variants = JSON.parse(form.querySelector('.variant-data').textContent); }
    catch { continue; }
    const input = form.elements.quantity;
    const submit = form.querySelector('[type="submit"]');
    const presets = form.querySelector('[data-quantity-presets]');
    const selected = () => variants.find(variant => variant.id === Number(form.elements.id.value));
    formData.set(form, selected);
    const refresh = () => {
      const variant = selected();
      const max = Math.max(0, Math.min(30, Number.isInteger(variant?.maxQuantity) ? variant.maxQuantity : 30));
      input.max = Math.max(1, max);
      for (const button of form.querySelectorAll('[data-quantity-preset]')) {
        const quantity = Number(button.dataset.quantityPreset);
        const unavailable = !variant?.available || !Number.isInteger(variant?.price) || variant.price <= 0 || quantity > max;
        button.dataset.locked = String(unavailable);
        button.disabled = unavailable || (submit.disabled && input.disabled);
        button.setAttribute('aria-pressed', String(Number(input.value) === quantity));
        if (quantity > 1 && variant) {
          form.querySelector('.bulk-total').textContent = money(window.ToscaCartonTotal(variant.id, variant.price, quantity));
        }
      }
    };
    form.addEventListener('input', refresh);
    form.addEventListener('change', refresh);
    // Capture also protects programmatic requestSubmit; Shopify remains the live stock authority.
    form.addEventListener('submit', event => {
      refresh();
      const variant = selected();
      const valid = variant?.available && Number.isInteger(variant.price) && variant.price > 0 && form.dataset.planRequired !== 'true' && input.checkValidity();
      if (!valid) {
        event.preventDefault();
        event.stopImmediatePropagation();
        input.reportValidity();
      }
    }, true);
    for (const button of form.querySelectorAll('[data-quantity-preset]')) {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        input.value = button.dataset.quantityPreset;
        input.dispatchEvent(new Event('input', {bubbles: true}));
        input.dispatchEvent(new Event('change', {bubbles: true}));
      });
    }
    new MutationObserver(refresh).observe(submit, {attributes: true, attributeFilter: ['disabled']});
    if (presets) presets.hidden = false;
    refresh();
  }

  const form = document.querySelector('.pdp-buy');
  const bar = document.querySelector('[data-product-sticky]');
  if (!form || !bar) return;
  const submit = form.querySelector('[type="submit"]');
  const stickySubmit = bar.querySelector('[data-sticky-add]');
  const total = bar.querySelector('[data-sticky-total]');
  const quantityText = bar.querySelector('[data-sticky-quantity]');
  const footer = document.querySelector('footer');
  const dialog = document.querySelector('#cart-dialog');
  const nav = document.querySelector('header nav');
  let scheduled = false;
  function refreshSticky() {
    scheduled = false;
    const quantity = Number(form.elements.quantity.value);
    const variant = formData.get(form)?.();
    const valid = variant?.available && Number.isInteger(quantity) && quantity > 0 && quantity <= Number(form.elements.quantity.max);
    const unit = form.dataset.unit || 'pack';
    const units = quantity === 1 ? unit : unit === 'box' ? 'boxes' : unit + 's';
    const selectedTotal = valid ? window.ToscaCartonTotal(variant.id, variant.price, quantity) : 0;
    total.textContent = valid ? money(window.ToscaShop?.taxesIncluded ? selectedTotal : selectedTotal + Math.round(selectedTotal / 10)) : 'Check quantity';
    quantityText.textContent = valid ? quantity + ' ' + units + ' · incl. GST' : 'Choose a whole number of packs';
    stickySubmit.disabled = submit.disabled || !valid;
    stickySubmit.textContent = submit.textContent;
    stickySubmit.setAttribute('aria-label', 'Add ' + quantity + ' ' + units + ' of ' + form.dataset.productTitle + ' to your order');
    const editable = document.activeElement?.matches('input,select,textarea,[contenteditable="true"]');
    const viewport = window.visualViewport;
    const keyboard = viewport && (viewport.height < window.innerHeight - 130 || viewport.scale > 1.2);
    const show = window.matchMedia('(max-width: 700px)').matches && window.innerHeight >= 450 && !editable && !keyboard && !dialog?.open && !nav?.classList.contains('open') && submit.getBoundingClientRect().bottom < 0 && (!footer || footer.getBoundingClientRect().top > window.innerHeight + 8);
    bar.hidden = !show;
    document.documentElement.classList.toggle('has-product-sticky', show);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(refreshSticky);
  }
  form.addEventListener('input', schedule);
  form.addEventListener('change', schedule);
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule, {passive: true});
  window.visualViewport?.addEventListener('resize', schedule, {passive: true});
  window.visualViewport?.addEventListener('scroll', schedule, {passive: true});
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  new MutationObserver(schedule).observe(submit, {attributes: true, childList: true, characterData: true, subtree: true});
  if (dialog) {
    new MutationObserver(schedule).observe(dialog, {attributes: true, attributeFilter: ['open']});
    // Reveal the external submitter before the shared drawer restores keyboard focus.
    dialog.addEventListener('close', refreshSticky, {capture: true});
  }
  if (nav) new MutationObserver(schedule).observe(nav, {attributes: true, attributeFilter: ['class']});
  refreshSticky();
})();
